import React, { useEffect, useRef, useState } from 'react';
import InfiniteSlider from '../../DnDInfiniteSlider/InfiniteSlider';
import { ChildComponents } from '../../DnDChildComponents';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { useSelector } from "react-redux";

function BannerSliderBase({ item, imageWidth, aspectRatio, activeBigger, isCentered }) {
  const images = item?.data?.images || []
  const [reset, forceReset] = useState(false)
  const min = item?.variantData?.minImage
  const customization = staticComponentValueConverter(item?.customization)
  const imageHashMap = useSelector(state => state.themeSlice?.imageHashMap)


  useEffect(() => {
    forceReset(state => !state)
  }, [item?.customization?.containerPadding, item?.customization?.imageWidth, images?.length])

  const renderImages = images.map((imgObj, index) => (
    <React.Fragment key={index}>
      <div className='flex flex-col relative  min-w-full'>
        <div className=' relative min-w-full'
          style={{
            padding: `${customization?.padding}`
          }}>
          <div>
            {imgObj?.image?.type === "video" ?

              <video
                style={{
                  aspectRatio: aspectRatio,
                  objectFit: customization?.backgroundSize,
                  borderRadius: customization?.borderRadius,
                  boxShadow: ChildComponents[customization?.boxShadow]?.data,
                }}
                autoPlay muted playsInline loop src={imgObj?.image?.src}

              ></video>
              :
              <img className='w-full' src={imgObj?.useCustomImage ? imgObj?.image?.src : imageHashMap[imgObj?.id]?.image} style={{
                aspectRatio: aspectRatio,
                objectFit: customization?.backgroundSize,
                borderRadius: customization?.borderRadius,
                boxShadow: ChildComponents[customization?.boxShadow]?.data
              }}
              />
            }
          </div>
        </div>
      </div>
    </React.Fragment>
  ))


  return (
    <>
      {images?.length >= min ? <div className='`overflow-x-visible relative'
        style={{
          padding: `${customization?.containerPadding}`,
          backgroundColor: customization?.backgroundType === "backgroundColor" ? customization?.backgroundColor : "",
          backgroundImage: customization?.backgroundType === "backgroundImage" ? `url(${customization?.backgroundImage})` : "",
          backgroundSize: "cover",
          backgroundPosition: "center center",
        }}
      >
        <div className={`collection-slider relative `}>
          <div
            style={{
              fontWeight: customization?.textWeight,
              fontStyle: customization?.textStyle,
              fontSize: (customization?.textSize),
              color: customization?.textColor,
              textAlign: customization?.textAlignment,
              letterSpacing: customization?.textLetterSpacing,
            }}
          >{item?.data?.text}</div>
          <div className="collection--slider flex flex-col" >
            <InfiniteSlider
              activeAnimationCoefficient={1}
              pausedAnimationCoefficient={1}
              forceReset={reset}
              sliderId={item?.id}
              isCentered={isCentered}
              activeBigger={activeBigger}
              classNames={{
                SliderItemWrapper: "image-wrapper pr-2 flex flex-col min-w-full"
              }}

              styles={{
                SliderItemWrapper:
                {
                  display: "flex",
                  minWidth: (imageWidth || item?.customization?.imageWidth || 100) + "%",
                  maxWidth: (imageWidth || item?.customization?.imageWidth || 100) + "%",
                  height: "auto",
                  wordSpacing: `${customization?.textWordSpacing}px`,
                  letterSpacing: `${customization?.textLetterSpacing}px`,
                }
              }}
            >

              {renderImages}

            </InfiniteSlider>
          </div>
        </div>
      </div> :
        <img src={item?.placeholderImage} className={` w-full `} />
      }
    </>
  );
}

export default BannerSliderBase;